import type { Plugin } from "vue";
import type { TAppConfig } from "~ui/@application/configs/config-schema.ts";

import * as Sentry from "@sentry/vue";
import piniaPluginPersistedState from "pinia-plugin-persistedstate";
import { createPiniaInstance } from "~ui/@application/configs/pinia-config.ts";

type TVoltexploitPiniaConfigurationPluginOptions = {
  config: TAppConfig;
};

export const voltexploitPiniaConfigurationPlugin = {
  install(app, options: TVoltexploitPiniaConfigurationPluginOptions) {
    const { config } = options;
    const pinia = createPiniaInstance(config);
    pinia.use(piniaPluginPersistedState);

    if (config.VITE_SENTRY_ENABLED) {
      pinia.use(
        Sentry.createSentryPiniaPlugin({
          attachPiniaState: true,
          addBreadcrumbs: true,
        }),
      );
    }

    app.use(pinia);
  },
} satisfies Plugin;
